<template>
  <div>
    <!-- 房产列表 -->
    <main class="pt-[72px]">
      <div class="max-w-[1440px] pt-20 pb-20 mt-20 mx-auto px-4 sm:px-8 py-6 sm:py-12">
        <div class="flex flex-col gap-8 lg:flex-row">
          <div class="w-full">
            <div class="flex flex-col items-start justify-between gap-4 mb-8 sm:flex-row sm:items-center sm:gap-0">
              <p class="text-lg">{{ $t('views.Properties.164486-0') }} <span class="font-semibold">245</span> {{
                $t('views.Properties.164486-1') }}</p>
              <div class="relative group">
                <button
                  class="flex items-center space-x-2 px-4 py-2 border border-gray-200 !rounded-button hover:border-primary">
                  <span>{{ $t('views.Properties.164486-2') }}</span>
                  <span class="font-medium">{{ $t('views.Properties.164486-3') }}</span>
                  <i class="text-sm transition-transform fas fa-chevron-down group-hover:rotate-180"></i>
                </button>
                <div class="absolute right-0 mt-2 w-48 bg-white shadow-lg !rounded-lg py-2 hidden group-hover:block z-10">
                  <button class="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-50">{{
                    $t('views.Properties.164486-3') }}</button>
                  <button class="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-50">{{
                    $t('views.Properties.164486-4') }}</button>
                  <button class="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-50">{{
                    $t('views.Properties.164486-5') }}</button>
                  <button class="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-50">{{
                    $t('views.Properties.164486-6') }}</button>
                </div>
              </div>
            </div>

            <!-- 房产卡片 -->
            <div class="grid grid-cols-1 gap-6 mb-12 md:grid-cols-2 lg:grid-cols-3">

              <div class="bg-white shadow-lg !rounded-lg overflow-hidden" v-for="(property, index) in properties"
                :key="index">
                <div class="relative h-[240px]">
                  <img :src="property.image" class="object-cover w-full h-full" :alt="property.title">
                  <div class="absolute top-4 left-4 bg-primary text-white px-3 py-1 !rounded-full text-sm">{{
                    $t('components.PropertyCard.766278-0') }}</div>
                </div>
                <div class="p-6">
                  <h3 class="mb-2 text-xl font-bold">{{ property.title }}</h3>
                  <p class="mb-4 text-gray-600"><i class="mr-2 fas fa-map-marker-alt text-primary"></i>{{
                    property.location }}</p>
                  <div class="flex flex-wrap justify-between gap-2 mb-4">
                    <span><i class="mr-2 text-gray-400 fas fa-bed"></i>{{ property.beds }} {{
                      $t('components.PropertyCard.766278-1') }}</span>
                    <span><i class="mr-2 text-gray-400 fas fa-bath"></i>{{ property.baths }} {{
                      $t('components.PropertyCard.766278-2') }}</span>
                    <span><i class="mr-2 text-gray-400 fas fa-vector-square"></i>{{ property.area }}</span>
                  </div>
                  <div class="mb-4">
                    <p class="text-sm text-gray-600">{{ $t('components.PropertyCard.766278-3') }}</p>
                    <p class="text-xl font-bold text-primary">{{ property.price }}</p>
                  </div>
                  <button @click="jumpTo(1)"
                    class="w-full bg-primary text-white px-6 py-2 !rounded-button hover:bg-opacity-90 transition-colors">{{
                      $t('components.PropertyCard.766278-4') }}</button>
                </div>
              </div>
            </div>

            <!-- 分页 -->
            <!-- <div class="flex flex-col items-center justify-between gap-4 mt-8 sm:flex-row sm:gap-0">
              <a href="#"
                class="flex items-center space-x-2 px-4 py-2 border border-gray-200 !rounded-button hover:border-primary disabled:opacity-50"
                disabled>
                <i class="fas fa-chevron-left"></i>
                <span>{{ $t('views.Properties.164486-7') }}</span>
              </a>
              <div class="flex flex-wrap items-center justify-center space-x-2 gap-y-2">
                <a href="#" class="w-10 h-10 flex items-center justify-center bg-primary text-white !rounded-button">1</a>
                <a href="#" class="w-10 h-10 flex items-center justify-center border border-gray-200 !rounded-button hover:border-primary hover:bg-primary hover:text-white">2</a>
                <a href="#" class="w-10 h-10 flex items-center justify-center border border-gray-200 !rounded-button hover:border-primary hover:bg-primary hover:text-white">3</a>
                <a href="#" class="w-10 h-10 flex items-center justify-center border border-gray-200 !rounded-button hover:border-primary hover:bg-primary hover:text-white">4</a>
                <a href="#" class="w-10 h-10 flex items-center justify-center border border-gray-200 !rounded-button hover:border-primary hover:bg-primary hover:text-white">5</a>
                <a href="#" class="w-10 h-10 flex items-center justify-center border border-gray-200 !rounded-button hover:border-primary hover:bg-primary hover:text-white">6</a>
                <span class="px-2">...</span>
                <a href="#" class="w-10 h-10 flex items-center justify-center border border-gray-200 !rounded-button hover:border-primary hover:bg-primary hover:text-white">15</a>
              </div>
              <a href="#"
                class="flex items-center space-x-2 px-4 py-2 border border-gray-200 !rounded-button hover:border-primary">
                <span>{{ $t('views.Properties.164486-8') }}</span>
                <i class="fas fa-chevron-right"></i>
              </a>
            </div> -->
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import navigation from '@/mixins/navigation'

export default {
  name: 'PropertiesPage',
  mixins: [navigation],

  data() {
    return {
      properties: [
        {
          title: this.$t('views.Properties.164486-9'),
          location: this.$t('views.Properties.164486-10'),
          beds: 5,
          baths: 6,
          area: this.$t('views.Properties.164486-11'),
          price: '$12,500,000',
          image: require('../assets/images/021093efe7b930affef407a20c7240e2.jpg')
        },
        {
          title: this.$t('views.Properties.164486-12'),
          location: this.$t('views.Properties.164486-13'),
          beds: 4,
          baths: 4.5,
          area: this.$t('views.Properties.164486-14'),
          price: '$8,900,000',
          image: require('../assets/images/a61b045cc30f4ca019df064314f4361c.jpg')
        },
        {
          title: this.$t('views.Properties.164486-15'),
          location: this.$t('views.Properties.164486-16'),
          beds: 6,
          baths: 7,
          area: this.$t('views.Properties.164486-17'),
          price: '$15,750,000',
          image: require('../assets/images/46a46bd93530a90286d6c14aef940a94.jpg')
        },
        {
          title: this.$t('views.Properties.164486-18'),
          location: this.$t('views.Properties.164486-19'),
          beds: 7,
          baths: 8,
          area: this.$t('views.Properties.164486-20'),
          price: '$18,900,000',
          image: require('../assets/images/0d48e8562eaebb520152b56c97a98187.jpg')
        },
        {
          title: this.$t('views.Properties.164486-21'),
          location: this.$t('views.Properties.164486-22'),
          beds: 6,
          baths: 7.5,
          area: this.$t('views.Properties.164486-23'),
          price: '$14,250,000',
          image: require('../assets/images/adb82dd6a64f3c5d4af87794618dfde8.jpg')
        },
        {
          title: this.$t('views.Properties.164486-24'),
          location: this.$t('views.Properties.164486-25'),
          beds: 5,
          baths: 6,
          area: this.$t('views.Properties.164486-26'),
          price: '$11,500,000',
          image: require('../assets/images/2ef8270b82a74494a1e37a4c56a02397.jpg')
        }
      ]
    }
  }
}
</script>

<style>
body {
  min-height: 1024px;
  font-family: 'Playfair Display', serif;
}

.search-input:focus {
  outline: none;
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  background: #C5A572;
  border-radius: 50%;
  cursor: pointer;
}
</style>